import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import ShowMap from "../ShowMap/ShowMap";
import { FaTag, FaPhone, FaRoad } from "react-icons/fa";
import "./Responsive.scss";
import "./MarketService.scss";

const MarketService = (props) => {
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  useEffect(() => {
    if (props.lat && props.long) {
      setLat(props.lat);
      setLong(props.long);
    }
  }, [props.lat, props.long]);
  return (
    <div className={`servicesWrapper markets mobile ${props.maxWidth ? "maxWidth" : ""}`}>
      <div className="serviceItem">
        <div className="contentWrapper">
          <div className="column first">
            <div className="serviceAddress">
              <FaTag className="icon" />
              آدرس : <span className="specColor">{props.address}</span>
            </div>
            <div className="serviceAddress">
              <FaPhone className="icon" />
              شماره تماس : <span className="specColor">{props.telephone}</span>
            </div>
            <div className="road">
              <div className="serviceAddress">
                <FaRoad className="icon" />
                <span className="specColor">{props.origin}</span>
              </div>
              <div className="serviceAddress">به</div>
              <div className="serviceAddress">
                <span className="specColor">{props.destination}</span>
              </div>
            </div>
          </div>
        </div>

        {lat && long && (
          <div className="serviceMapWrapper market">
            <ShowMap
              height={400}
              defaultCenter={[parseFloat(lat), parseFloat(long)]}
              anchor={[parseFloat(lat), parseFloat(long)]}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(withRouter(MarketService));
